import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { LinearProgress } from "../../../ui/LinearProgress";
import { Meta } from "../../Meta/Meta";
import { NoData } from "../../NoData/NoData";
import { useOrderDetails } from "../useOrderDetails";
import { CartHeader } from "./CartHeader";
import { CartLegalInfo } from "./CartLegalInfo";
import { CartNotes } from "./CartNotes";
import { CartOrders } from "./CartOrders";
import { CartStatus } from "./CartStatus";
import { CartTotal } from "./CartTotal";
import { ContactDealerForm } from "./ContactDealerForm";
import { XTimeAppointment } from "./XTimeAppointment/XTimeAppointment";
import { PriceMatchDialog } from "./items/PriceMatchDialog/PriceMatchDialog";

export const CartPage: FunctionComponent = () => {
  const { t } = useTranslation();
  const { data, isLoading, isOrder } = useOrderDetails();

  const hasData = Boolean(data?.orderItemList.length);

  return (
    <>
      <Meta cmsTitle={null} title="dealerCartPage" />
      <div className="2xl:mx-0 grid gap-2">
        <CartHeader isOrder={isOrder} />
        {isLoading && !hasData && <LinearProgress className="h-0.5" />}
        {!hasData && !isLoading && (
          <NoData className="py-8 lg:py-16">{t("cart.noOrders")}</NoData>
        )}
        {hasData && (
          <section className="grid gap-4 lg:grid-cols-3 2xl:gap-8">
            <div className="grid lg:col-span-2">
              <div className="space-y-4">
                <CartStatus
                  orderCreatedTimestamp={data?.orderCreatedTimestamp ?? ""}
                  orderId={data?.orderId ?? null}
                />
                <XTimeAppointment />
                <CartOrders />
                <CartNotes />
                <CartLegalInfo />
              </div>
            </div>
            <aside>
              <div className="grid md:grid-cols-2 lg:grid-cols-1 gap-4 2xl:gap-8">
                <span>
                  <CartTotal />
                </span>
                <span>
                  <ContactDealerForm orderDetails={data} />
                </span>
              </div>
            </aside>
          </section>
        )}
      </div>
      <PriceMatchDialog />
    </>
  );
};
